document.addEventListener('DOMContentLoaded', () => {
  const normalizeText = (text = '') =>
    text
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[¿?¡!….,:]/g, '')
      .replace(/\s+/g, ' ')
      .trim();

  const headings = Array.from(document.querySelectorAll('h2'));

  const quickInfoHeading = headings.find((heading) =>
    normalizeText(heading.textContent).includes('informacion rapida')
  );

  if (!quickInfoHeading) return;

  let description = quickInfoHeading.parentElement;

  while (
    description &&
    description !== document.body &&
    !Array.from(description.querySelectorAll('h2')).some((heading) =>
      normalizeText(heading.textContent).includes('vale la pena probarlo')
    )
  ) {
    description = description.parentElement;
  }

  if (!description || description === document.body) return;

  /*
   * Clase propia para controlar únicamente
   * las descripciones de producto de MrDecant.
   */
  description.classList.add('mrd-product-description');

  const allHeadings = Array.from(description.querySelectorAll('h2'));

  const findHeading = (...terms) =>
    allHeadings.find((heading) => {
      const text = normalizeText(heading.textContent);

      return terms.some((term) =>
        text.includes(normalizeText(term))
      );
    });

  const startForYou = findHeading(
    'lo disfrutaras muchisimo si',
    'es para ti',
    'probablemente si si buscas',
    'probablemente si, si buscas'
  );

  const quickInfo = findHeading(
    'informacion rapida'
  );

  const whyStandOut = findHeading(
    'por que destaca'
  );

  const recommendation = findHeading(
    'nuestra recomendacion'
  );

  const related = findHeading(
    'si este perfume te gusto',
    'tambien podrian interesarte'
  );

  const purchaseIncludes = findHeading(
    'tu compra incluye'
  );

  const sections = [];

  if (startForYou && quickInfo) {
    sections.push({
      title: '¿Este perfume es para ti?',
      start: startForYou,
      end: quickInfo
    });
  }

  if (quickInfo && whyStandOut) {
    sections.push({
      title: 'Información rápida',
      start: quickInfo,
      end: whyStandOut
    });
  }

  if (whyStandOut && recommendation) {
    sections.push({
      title: '¿Por qué destaca?',
      start: whyStandOut,
      end: recommendation
    });
  }

  if (recommendation) {
    sections.push({
      title: 'Nuestra recomendación',
      start: recommendation,
      end: related || purchaseIncludes || null
    });
  }

  if (related && purchaseIncludes) {
    sections.push({
      title: 'También podrían interesarte',
      start: related,
      end: purchaseIncludes
    });
  }

  if (purchaseIncludes) {
    sections.push({
      title: 'Tu compra incluye',
      start: purchaseIncludes,
      end: null
    });
  }

  const createAccordion = ({ title, start, end }) => {
    if (!start || start.dataset.mrdProcessed === 'true') return;

    const details = document.createElement('details');
    details.className = 'mrd-product-accordion';

    const summary = document.createElement('summary');
    summary.className = 'mrd-product-accordion__summary';

    const titleSpan = document.createElement('span');
    titleSpan.className = 'mrd-product-accordion__title';
    titleSpan.textContent = title;

    const icon = document.createElement('span');
    icon.className = 'mrd-product-accordion__icon';
    icon.textContent = '+';
    icon.setAttribute('aria-hidden', 'true');

    summary.append(titleSpan, icon);

    const content = document.createElement('div');
    content.className = 'mrd-product-accordion__content';

    start.parentNode.insertBefore(details, start);

    details.appendChild(summary);
    details.appendChild(content);

    let node = start;

    while (node && node !== end) {
      const next = node.nextSibling;
      content.appendChild(node);
      node = next;
    }

    start.dataset.mrdProcessed = 'true';

    details.addEventListener('toggle', () => {
      icon.textContent = details.open ? '−' : '+';
    });
  };

  sections.forEach(createAccordion);

  const style = document.createElement('style');

  style.textContent = `

    /* ==========================================
       MRDECANT - DESCRIPCIÓN GENERAL
       ========================================== */

    .mrd-product-description {
      width: 100% !important;
      max-width: 100% !important;
      min-width: 0 !important;
      box-sizing: border-box !important;
      color: var(--color-foreground);
    }

    .mrd-product-description * {
      box-sizing: border-box;
      max-width: 100%;
    }


    /* ==========================================
       TEXTO NARRATIVO
       ========================================== */

    .mrd-product-description p {
      max-width: 100%;
      margin-top: 0;
      margin-bottom: 1rem;
      font-size: 1rem;
      line-height: 1.65;
      white-space: normal;
      overflow-wrap: anywhere;
      word-wrap: break-word;
      word-break: normal;
    }

    .mrd-product-description p + p {
      margin-top: -0.1rem;
    }


    /* ==========================================
       TÍTULOS DE LA DESCRIPCIÓN
       ========================================== */

    .mrd-product-description h2 {
      max-width: 100%;
      margin-top: 2rem;
      margin-bottom: 1rem;
      font-size: 1.45rem;
      line-height: 1.25;
      font-weight: 700;
      letter-spacing: -0.01em;
      color: var(--color-foreground-heading);
      white-space: normal;
      overflow-wrap: anywhere;
      word-break: normal;
    }

    .mrd-product-description > h2:first-child {
      margin-top: 0;
    }


    /* ==========================================
       NEGRITAS NORMALES
       ========================================== */

    .mrd-product-description strong,
    .mrd-product-description b {
      max-width: 100%;
      white-space: normal;
      overflow-wrap: anywhere;
      word-break: normal;
    }


    /*
     * CORRECCIÓN:
     * Mantiene las negritas dentro de la misma oración.
     * Evita que "3 ml, 5 ml y 10 ml" quede aislado
     * o centrado en una línea independiente.
     */

    .mrd-product-description p > strong,
    .mrd-product-description p > b,
    .mrd-product-accordion__content p > strong,
    .mrd-product-accordion__content p > b {
      display: inline !important;
      width: auto !important;
      max-width: none !important;
      margin: 0 !important;
      padding: 0 !important;
      text-align: inherit !important;
      font-size: inherit !important;
      line-height: inherit !important;
      white-space: normal !important;
      overflow-wrap: anywhere !important;
      word-break: normal !important;
    }


    /* ==========================================
       BLOCKQUOTES
       ========================================== */

    .mrd-product-description blockquote {
      width: auto;
      max-width: 100%;
      margin: 1.5rem 0;
      padding: 0 0 0 16px;

      border-left:
        2px solid
        rgba(201, 162, 39, 0.65);

      box-sizing: border-box;
      white-space: normal;
      overflow-wrap: anywhere;
      word-break: normal;
    }


    /* ==========================================
       ACORDEONES MRDECANT
       ========================================== */

    .mrd-product-accordion {
      width: 100%;
      max-width: 100%;
      min-width: 0;
      margin: 0;
      padding: 0;
      box-sizing: border-box;

      border-top:
        1px solid
        rgba(255, 255, 255, 0.18);

      background: transparent !important;
      color: inherit;
    }

    .mrd-product-accordion:first-of-type {
      border-top: none;
    }

    .mrd-product-accordion:last-of-type {
      border-bottom:
        1px solid
        rgba(255, 255, 255, 0.18);
    }


    /* ==========================================
       CABECERA DEL ACORDEÓN
       ========================================== */

    .mrd-product-accordion__summary {
      display: flex !important;
      align-items: center;
      justify-content: space-between;
      gap: 16px;

      width: 100%;
      max-width: 100%;
      min-width: 0;

      padding: 17px 0;
      margin: 0;

      box-sizing: border-box;
      cursor: pointer;
      list-style: none;

      font-weight: 600;
      font-size: 1rem;
      line-height: 1.35;

      color:
        var(--color-foreground) !important;

      background:
        transparent !important;

      opacity: 1 !important;
      visibility: visible !important;
      text-decoration: none !important;

      transition:
        color 0.2s ease,
        opacity 0.2s ease;
    }

    .mrd-product-accordion__summary::-webkit-details-marker {
      display: none;
    }

    .mrd-product-accordion__summary::marker {
      content: '';
    }


    /* ==========================================
       HOVER / FOCUS
       ========================================== */

    .mrd-product-accordion__summary:hover,
    .mrd-product-accordion__summary:focus,
    .mrd-product-accordion__summary:active,
    .mrd-product-accordion__summary:focus-visible,
    .mrd-product-accordion[open]
      > .mrd-product-accordion__summary {

      color:
        var(--color-foreground) !important;

      background:
        transparent !important;

      opacity: 1 !important;
      visibility: visible !important;
      text-decoration: none !important;
    }


    /* ==========================================
       TÍTULO DEL ACORDEÓN
       ========================================== */

    .mrd-product-accordion__title {
      display: block !important;

      flex:
        1
        1
        auto;

      min-width: 0;
      max-width: 100%;

      color:
        var(--color-foreground) !important;

      opacity: 1 !important;
      visibility: visible !important;

      white-space:
        normal !important;

      overflow-wrap:
        anywhere !important;

      word-break:
        normal !important;
    }


    /* ==========================================
       + / − DORADO
       ========================================== */

    .mrd-product-accordion__icon {
      display: flex;
      align-items: center;
      justify-content: center;

      flex:
        0
        0
        auto;

      min-width: 20px;
      font-size: 1.35rem;
      font-weight: 300;
      line-height: 1;

      color:
        #c9a227 !important;

      opacity:
        1 !important;

      visibility:
        visible !important;
    }


    /* ==========================================
       CONTENIDO DEL ACORDEÓN
       ========================================== */

    .mrd-product-accordion__content {
      width: 100%;
      max-width: 100%;
      min-width: 0;

      padding:
        2px
        0
        20px;

      box-sizing: border-box;
      color: inherit;
    }

    .mrd-product-accordion__content
      > h2:first-child {
      display: none !important;
    }

    .mrd-product-accordion__content
      > *:first-child {
      margin-top: 0;
    }

    .mrd-product-accordion__content
      > *:last-child {
      margin-bottom: 0;
    }


    /* ==========================================
       PROTECCIÓN GENERAL CONTRA DESBORDAMIENTO
       ========================================== */

    .mrd-product-description p,
    .mrd-product-description h1,
    .mrd-product-description h2,
    .mrd-product-description h3,
    .mrd-product-description h4,
    .mrd-product-description h5,
    .mrd-product-description h6,
    .mrd-product-description strong,
    .mrd-product-description b,
    .mrd-product-description em,
    .mrd-product-description span,
    .mrd-product-description div,
    .mrd-product-description blockquote,

    .mrd-product-accordion__content p,
    .mrd-product-accordion__content h1,
    .mrd-product-accordion__content h2,
    .mrd-product-accordion__content h3,
    .mrd-product-accordion__content h4,
    .mrd-product-accordion__content strong,
    .mrd-product-accordion__content b {

      max-width: 100%;
      box-sizing: border-box;
      white-space: normal;
      overflow-wrap: anywhere;
      word-wrap: break-word;
      word-break: normal;
    }


    /* ==========================================
       MULTIMEDIA
       ========================================== */

    .mrd-product-description img,
    .mrd-product-description video,
    .mrd-product-description iframe,

    .mrd-product-accordion__content img,
    .mrd-product-accordion__content video,
    .mrd-product-accordion__content iframe {

      max-width:
        100% !important;

      height: auto;

      box-sizing:
        border-box;
    }


    /* ==========================================
       MÓVIL
       ========================================== */

    @media screen and (max-width: 749px) {

      .mrd-product-description {
        width:
          100% !important;

        max-width:
          100% !important;

        min-width:
          0 !important;

        box-sizing:
          border-box !important;
      }

      .mrd-product-description * {
        max-width:
          100% !important;

        box-sizing:
          border-box !important;
      }


      /* PÁRRAFOS */

      .mrd-product-description p {
        margin-top: 0;

        margin-bottom:
          0.88rem;

        font-size:
          0.96rem;

        line-height:
          1.58;

        letter-spacing:
          0;
      }

      .mrd-product-description p + p {
        margin-top:
          -0.08rem;
      }


      /* TÍTULOS */

      .mrd-product-description h2 {
        margin-top:
          1.7rem;

        margin-bottom:
          0.8rem;

        font-size:
          1.27rem;

        line-height:
          1.25;

        font-weight:
          700;

        letter-spacing:
          -0.01em;
      }


      /* BLOCKQUOTES */

      .mrd-product-description blockquote {
        width:
          auto !important;

        max-width:
          100% !important;

        margin:
          1.3rem
          0;

        padding-left:
          14px;

        padding-right:
          0;

        box-sizing:
          border-box !important;

        white-space:
          normal !important;

        overflow-wrap:
          anywhere !important;
      }


      /* ACORDEONES */

      .mrd-product-accordion {
        width:
          100% !important;

        max-width:
          100% !important;

        min-width:
          0 !important;
      }

      .mrd-product-accordion__summary {
        padding:
          14px
          0;

        gap:
          12px;

        font-size:
          0.94rem;

        line-height:
          1.3;

        font-weight:
          600;

        width:
          100% !important;

        max-width:
          100% !important;

        min-width:
          0 !important;
      }

      .mrd-product-accordion__title {
        min-width:
          0 !important;

        max-width:
          100% !important;

        white-space:
          normal !important;

        overflow-wrap:
          anywhere !important;

        word-break:
          normal !important;
      }

      .mrd-product-accordion__icon {
        min-width:
          18px;

        font-size:
          1.25rem;

        flex-shrink:
          0;
      }

      .mrd-product-accordion__content {
        padding:
          2px
          0
          17px;

        width:
          100% !important;

        max-width:
          100% !important;

        min-width:
          0 !important;
      }


      /* PROTECCIÓN DE TEXTO */

      .mrd-product-description p,
      .mrd-product-description h1,
      .mrd-product-description h2,
      .mrd-product-description h3,
      .mrd-product-description h4,
      .mrd-product-description h5,
      .mrd-product-description h6,
      .mrd-product-description strong,
      .mrd-product-description b,
      .mrd-product-description em,
      .mrd-product-description span,

      .mrd-product-accordion__content p,
      .mrd-product-accordion__content h1,
      .mrd-product-accordion__content h2,
      .mrd-product-accordion__content h3,
      .mrd-product-accordion__content strong,
      .mrd-product-accordion__content b {

        max-width:
          100% !important;

        min-width:
          0 !important;

        white-space:
          normal !important;

        overflow-wrap:
          anywhere !important;

        word-wrap:
          break-word !important;

        word-break:
          normal !important;
      }


      /* ELEMENTOS CON ANCHO INLINE */

      .mrd-product-description [style*="width"],
      .mrd-product-accordion__content [style*="width"] {

        max-width:
          100% !important;

        box-sizing:
          border-box !important;
      }


      /* MULTIMEDIA */

      .mrd-product-description img,
      .mrd-product-description video,
      .mrd-product-description iframe,

      .mrd-product-accordion__content img,
      .mrd-product-accordion__content video,
      .mrd-product-accordion__content iframe {

        max-width:
          100% !important;

        height:
          auto !important;
      }

    }


    /* ==========================================
       TELÉFONOS PEQUEÑOS
       ========================================== */

    @media screen and (max-width: 390px) {

      .mrd-product-description p {
        font-size:
          0.94rem;

        line-height:
          1.56;

        margin-bottom:
          0.82rem;
      }

      .mrd-product-description h2 {
        font-size:
          1.2rem;

        margin-top:
          1.55rem;

        margin-bottom:
          0.72rem;
      }

    }

  `;

  document.head.appendChild(style);
});